export const ExternalLinks = {
  GG_CANCELLATION_KB: 'https://www.greengeeks.com/support/article/if-i-want-to-cancel-my-account/',
  GG_CUSTOM_NAMESERVERS_KB: 'https://www.greengeeks.com/support/article/how-to-set-default-name-servers-in-reseller-whm/',
}
export const parseIsoDate = {
  INVALID_DATE: 'Invalid Date',
}

export const notAvailable = {
  SHORT: 'N/A',
}

export const PRODUCTS_BILLING_PERIODS = {
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  SEMIANNUALLY: 'semiannually',
  ANNUALLY: 'annually',
  BIENNIALLY: 'biennially',
  TRIENNIALLY: 'triennially',
}
